module.exports = __webpack_public_path__ + "img/gl.642f2506.gif";